import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { reservationLedgerQueries } from '@/services/dashboard/reservationLedger/reservationLedger.queries';
import { useSearch } from '@tanstack/react-router';

const SORT_FIELD_MAP = {
  storeInfo: 'storeInfoJpn',
  reservationId: 'invoiceNumber',
  createdDate: 'visitingDateTime',
} as const;
export const useReservationLedgerList = () => {
  const { createdDate, page, fetch, q, clubStatusFilter, clubId, planTypeFilter, sort } = useSearch({
    from: '/(app)/dashboard/reservation-ledger/',
  });
  const parsedCreatedDate = parseDateRangeSearch(createdDate);
  const { data, isFetched, isLoading } = useQuery({
    ...reservationLedgerQueries.list({
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
      row: page,
      fetch: fetch,
      search: q,
      clubStatusFilter: clubStatusFilter,
      clubId: clubId,
      planTypeFilter: planTypeFilter,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort, SORT_FIELD_MAP),
    }),
  });

  return {
    reservationLedger: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
